import { getWebBaseHost } from '@/restful/request';

export function isWechat() {
  if (typeof window !== 'undefined') {
    return /MicroMessenger/i.test(window.navigator.userAgent);
  }
  return false;
}

export function isApp() {
  const regex = /com\.jbsn\.(sduck|sno)\b/;
  if (typeof window !== 'undefined') {
    return regex.test(navigator.userAgent);
  }
  return false;
}

export function isSduckApp() {
  const regex = /com\.jbsn\.sduck\b/;
  if (typeof window !== 'undefined') {
    return regex.test(navigator.userAgent);
  }
  return false;
}

export function isSnoApp() {
  const regex = /com\.jbsn\.sno\b/;
  if (typeof window !== 'undefined') {
    return regex.test(navigator.userAgent);
  }
  return false;
}

/**
 * 获取应用版本号
 * @returns 应用版本号字符串，如果未找到则返回空字符串
 */
export function getAppVersion(): string {
  if (typeof window === 'undefined') return '';

  const appVersionMatch = navigator.userAgent.match(/version_([\d\\.]+)/);
  return appVersionMatch ? appVersionMatch[1] : '';
}

/**
 * 获取VIP状态
 * @returns VIP状态，如果未找到则返回undefined
 */
export function getVipStatus(): boolean | undefined {
  if (typeof window === 'undefined') return undefined;

  const isVipMatch = navigator.userAgent.match(/isVip_(true|false)/);
  return isVipMatch ? isVipMatch[1] === 'true' : undefined;
}

/**
 * 获取永久VIP状态
 * @returns 永久VIP状态，如果未找到则返回undefined
 */
export function getPermanentVipStatus(): boolean | undefined {
  if (typeof window === 'undefined') return undefined;

  const isPermanentVipMatch = navigator.userAgent.match(
    /isPermanentVipUser_(true|false)/
  );
  return isPermanentVipMatch ? isPermanentVipMatch[1] === 'true' : undefined;
}

/**
 * 获取应用信息（版本、VIP状态等）
 * @returns 包含应用版本、VIP状态和永久VIP状态的对象
 */
export function getAppInfo() {
  return {
    version: getAppVersion(),
    isVip: getVipStatus(),
    isPermanentVip: getPermanentVipStatus(),
    userAgent: typeof window !== 'undefined' ? navigator.userAgent : '',
  };
}

export function compareVersion(version1: string, version2: string): boolean {
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);

  const length = Math.max(v1Parts.length, v2Parts.length);

  for (let i = 0; i < length; i++) {
    const v1 = v1Parts[i] || 0; // 若不存在则用 0 代替
    const v2 = v2Parts[i] || 0;

    if (v1 > v2) {
      return true;
    } else if (v1 < v2) {
      return false;
    }
  }

  return true; // 相等时返回 true
}

/** 当前版本是否大于传入版本 */
export function isGreaterThanVersion(version: string) {
  const currentVersion = getAppVersion();
  if (!currentVersion) {
    return false;
  }
  if (currentVersion === version) {
    return false;
  }
  return compareVersion(currentVersion, version);
}

// 根据环境生成url，主要在内嵌到APP中使用
// TODO 待修正，目前没生效
export function generateUrlByEnv(path: string) {
  return `${getWebBaseHost()}${path}`;
}
